module.exports = __webpack_public_path__ + "assets/img/picture.8719cc6d.png";